import React, { Component } from 'react';
import {
    Typography,
    Box,
    withStyles
} from '@material-ui/core';

const styles = theme => ({
    sectionBody: {
        padding: '1rem',
    },
    row: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    column: {
        flex: '0 0 auto',
        width: '50%',
    },
    columntTextEnd: {
        flex: '0 0 auto',
        width: '50%',
        textAlign: 'right !important',
    },
    bodyText: {
        fontSize: '1rem',
        fontWeight: 400,
        color: '#495057',
        marginBottom: '1rem',
    },
    label: {
        fontSize: '1rem',
        fontWeight: 600,
        color: '#495057',
        marginRight: '0.5rem',
    },
});

class DetailsClienteSection extends Component {
    formatarData = (data) => {
        if (!data) return '-';
        return new Date(data).toLocaleDateString('pt-BR');
    };

    render() {
        const { classes, cliente, currentLanguage } = this.props;

        if (!cliente) {
            return (
                <Typography variant="body2" color="textSecondary">
                    {currentLanguage.bepiService.shared.shared_details_no_client_msg}
                </Typography>
            );
        }

        return (
            <Box className={classes.sectionBody}>
                <Box className={classes.row}>
                    <Box className={classes.column}>
                        <Typography className={classes.bodyText}>
                            <span className={classes.label}>{currentLanguage.bepiService.shared.shared_details_company_label}</span>
                            {cliente.empresa || '-'}
                        </Typography>
                        <Typography className={classes.bodyText}>
                            <span className={classes.label}>{currentLanguage.bepiService.shared.shared_details_name_label}</span>
                            {cliente.nome || '-'}
                        </Typography>
                        <Typography className={classes.bodyText}>
                            <span className={classes.label}>{currentLanguage.bepiService.shared.shared_details_phone_label}</span>
                            {cliente.telefone || '-'}
                        </Typography>
                    </Box>
                    <Box className={classes.columntTextEnd}>
                        <Typography className={classes.bodyText}>
                            <span className={classes.label}>{currentLanguage.bepiService.shared.shared_details_cnpj_label}</span>
                            {cliente.cnpj || '-'}
                        </Typography>
                        <Typography className={classes.bodyText}>
                            <span className={classes.label}>{currentLanguage.bepiService.shared.shared_details_date_label}</span>
                            {this.formatarData(cliente.dt_criacao)}
                        </Typography>
                        <Typography className={classes.bodyText}>
                            <span className={classes.label}>{currentLanguage.bepiService.shared.shared_details_email_label}</span>
                            {cliente.email || '-'}
                        </Typography>
                    </Box>
                </Box>
            </Box>
        );
    }
}

export default withStyles(styles)(DetailsClienteSection);
